import axios from 'axios'
export default {
  namespaced: true,
  state: {
    languages: [],
  },
  mutations: {
    setLanguages(state, payload) {
      state.languages = payload
    },
  },
  getters: {
    languages: (state) => state.languages,
  },
  actions: {
    onLanguages({ commit }) {
      return new Promise((resolve, reject) => {
        axios({
          url: 'https://service.proapp.fi/langs.json',
          method: 'GET',
        })
          .then((resp) => {
            resolve(resp)
            let languages = resp.data
            let languages_keys = Object.keys(languages).sort()
            let lang = {}
            for (let i in languages_keys) {
              lang[languages_keys[i]] = languages[languages_keys[i]]
            }
            commit('setLanguages', lang)
            let languagesSelect = []
            if ($cookies.get('languageSelect')) {
              languagesSelect.push($cookies.get('languageSelect').key)
              let i = 0
              let j = 3
              while (i < j) {
                languages_keys[i] !== $cookies.get('languageSelect').key
                  ? languagesSelect.push(languages_keys[i])
                  : j++
                i++
              }
              commit('interfaceAdmin/setInterfaceAdminLanguagesSelect', languagesSelect, {
                root: true,
              })
            }
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
  },
}
